import React from 'react';
import { createRoot } from 'react-dom/client';
import MagicRings from './components/MagicRings';

const App = () => (
    <div style={{ width: '100%', height: '100%', position: 'absolute', inset: 0, zIndex: 0, opacity: 0.25 }}>
        <MagicRings
            color="#fc42ff"
            colorTwo="#42fcff"
            ringCount={6}
            speed={1}
            attenuation={10}
            lineThickness={2}
            baseRadius={0.35}
            radiusStep={0.1}
            scaleRate={0.1}
            opacity={1}
            blur={0}
            noiseAmount={0.1}
            rotation={0}
            ringGap={1.5}
            fadeIn={0.7}
            fadeOut={0.5}
            followMouse={true}
            mouseInfluence={0.2}
            hoverScale={1.2}
            parallax={0.05}
            clickBurst={true}
        />
    </div>
);

const container = document.getElementById('magic-rings-hero');
if (container) {
    const root = createRoot(container);
    root.render(<App />);
}
